var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.159 3.84766H1.93166C0.972005 3.84766 0.192566 4.62709 0.192566 5.58675V20.2609C0.192566 21.2206 0.972005 22 1.93166 22H12.159C13.1186 22 13.8981 21.2206 13.8981 20.2609V5.58675C13.8936 4.62709 13.1141 3.84766 12.159 3.84766ZM12.6771 20.2564C12.6771 20.5447 12.4428 20.779 12.1545 20.779H1.92716C1.63881 20.779 1.40453 20.5447 1.40453 20.2564V5.58675C1.40453 5.2984 1.63881 5.06412 1.92716 5.06412H12.1545C12.4428 5.06412 12.6771 5.2984 12.6771 5.58675V20.2564Z",
    fill: "#200E32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0699 0H5.84255C4.88289 0 4.10345 0.779439 4.10345 1.73909C4.10345 2.077 4.37378 2.34733 4.71169 2.34733C5.04959 2.34733 5.31992 2.077 5.31992 1.73909C5.31992 1.45075 5.5542 1.21647 5.84255 1.21647H16.0699C16.3582 1.21647 16.5925 1.45075 16.5925 1.73909V16.4133C16.5925 16.7016 16.3582 16.9359 16.0699 16.9359C15.732 16.9359 15.4616 17.2062 15.4616 17.5441C15.4616 17.882 15.732 18.1524 16.0699 18.1524C17.0295 18.1524 17.809 17.3729 17.809 16.4133V1.73909C17.809 0.779439 17.0295 0 16.0699 0Z",
    fill: "#200E32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.c499a7f41970df24817ab2f46bb43f64.svg";
export { ForwardRef as ReactComponent };